var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckmarkSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C6.816 0 7.596 0.156 8.34 0.468C9.052 0.772 9.684 1.204 10.236 1.764C10.796 2.316 11.228 2.948 11.532 3.66C11.844 4.404 12 5.184 12 6C12 6.816 11.844 7.596 11.532 8.34C11.228 9.052 10.796 9.684 10.236 10.236C9.684 10.796 9.052 11.228 8.34 11.532C7.596 11.844 6.816 12 6 12C5.184 12 4.404 11.844 3.66 11.532C2.948 11.228 2.312 10.796 1.752 10.236C1.2 9.684 0.772 9.052 0.468 8.34C0.156 7.596 0 6.816 0 6C0 5.184 0.156 4.404 0.468 3.66C0.772 2.948 1.2 2.316 1.752 1.764C2.312 1.204 2.948 0.772 3.66 0.468C4.404 0.156 5.184 0 6 0ZM5.256 8.568L9.312 4.5L8.244 3.432L5.256 6.444L4.056 5.244L3 6.3L5.256 8.568Z",
    fill: "#21812D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckmarkSuccess);
export default __webpack_public_path__ + "static/media/circle-checkmark-success.eac9751168435855b40e8a9797456222.svg";
export { ForwardRef as ReactComponent };